import { BigNumber } from 'ethers'
import TrophyMemoryDomainException from '~/modules/TrophyMemories/Domain/TrophyMemoryDomainException'
import { DateTime } from 'luxon'
import { FileUrl } from '~/modules/TrophyMemories/Domain/FileUrl'

export type SupportedExtension = 'jpg' | 'mp3' | 'mp4'

export type MediaType = 'audio' | 'video' | 'image'

export enum SupportedMedia {
  Audio = 'audio',
  Video = 'video',
  Image = 'image'
}

const allowedMediaExtensions = new Map<MediaType, SupportedExtension>([
  [SupportedMedia.Audio, 'mp3'],
  [SupportedMedia.Image, 'jpg'],
  [SupportedMedia.Video, 'mp4'],
])

export const MAX_MEMORIES_PER_TROPHY = 5

// TODO: Extract this const from here or even better, don't expose it in the domain
export const TrophyMemoryDirectory = 'trophies/memories'

export class TrophyMemory {
  public readonly id: string
  public readonly trophyId: BigNumber
  public readonly type: MediaType
  public readonly mediaUrl: string
  public readonly thumbnailUrl: string
  private readonly _createdAt: DateTime

  constructor (
    id: string,
    trophyId: BigNumber,
    type: MediaType,
    mediaUrl: FileUrl,
    thumbnailUrl: FileUrl,
    createdAt: DateTime
  ) {
    TrophyMemory.assertMediaTypeSupported(type, mediaUrl)
    this.id = id
    this.trophyId = trophyId
    this.type = type
    this.mediaUrl = mediaUrl.toString()
    this.thumbnailUrl = TrophyMemory.getThumbnailUrl(thumbnailUrl, type).toString()
    this._createdAt = createdAt
  }

  private static getThumbnailUrl (thumbnailUrl: FileUrl, type: MediaType): FileUrl {
    if (type === 'audio') {
      return thumbnailUrl
    }

    TrophyMemory.assertMediaTypeSupported('image', thumbnailUrl)

    return thumbnailUrl
  }

  private static assertMediaTypeSupported (
    mediaType: MediaType,
    mediaUrl: FileUrl
  ) {
    const values: string [] = Object.values(SupportedMedia)

    if (!values.includes(mediaType)) {
      throw TrophyMemoryDomainException.notSupported(mediaType)
    }

    const validMediaTypeExtension = allowedMediaExtensions.get(mediaType)

    if (validMediaTypeExtension !== mediaUrl.getExtension()) {
      throw TrophyMemoryDomainException.unsupportedFileExtension(mediaUrl.getExtension(), mediaType)
    }
  }

  get createdAt (): DateTime {
    return this._createdAt
  }
}
